import { useEffect, useState } from 'react';

export const useAudioInputMediaStream = (deviceId: string | null): MediaStream | null => {
   const [mediaStream, setMediaStream] = useState<MediaStream | null>(null);

   useEffect(() => {
      if (deviceId === null) {
         setMediaStream(null);
         return undefined;
      }

      let active = true;
      let stream: MediaStream | null = null;

      navigator.mediaDevices
         .getUserMedia({ audio: { deviceId: { exact: deviceId } } })
         .then((nextStream) => {
            if (!active) {
               nextStream.getTracks().forEach((track) => track.stop());
               return;
            }
            stream = nextStream;
            setMediaStream(nextStream);
         })
         .catch(() => {
            if (active) {
               setMediaStream(null);
            }
         });

      return () => {
         active = false;
         stream?.getTracks().forEach((track) => track.stop());
         setMediaStream(null);
      };
   }, [deviceId]);

   return mediaStream;
};
